/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const LOAD_REPOS = 'boilerplate/App/LOAD_REPOS';
export const LOAD_REPOS_SUCCESS = 'boilerplate/App/LOAD_REPOS_SUCCESS';
export const LOAD_REPOS_ERROR = 'boilerplate/App/LOAD_REPOS_ERROR';
export const DEFAULT_LOCALE = 'en';
export const SET_WORKSPACE_THEME = 'App/SET_WORKSPACE_THEME';
export const SET_NOTIFICATION_BANNER_HEIGHT = 'App/SET_NOTIFICATION_BANNER_HEIGHT';
export const TOGGLE_MOBILE_SIDEBAR = 'App/TOGGLE_MOBILE_SIDEBAR';
export const SET_AI_SUMMARY_PANEL = 'APP/SET_AI_SUMMARY_PANEL';
export const SET_REVIEWER_BANNER = 'APP/SET_REVIEWER_BANNER';
